import React, { useEffect, useRef, useState } from "react";
import ChatFooter from "../components/chat-window/ChatFooter";
import {
  getCustomerInfo,
  getFaqRelatedAnswer,
} from "../api-services/OneToOneConversation.api";
import useSocketStore from "../store/useSocketStore";
import useChatStore from "../store/useChatStore";
import { API_URL } from "../api-services/Environment";

const OneToOneChat = () => {
  const {
    socketInstance,
    connectSocket,
    disconnectSocket,
    setCustomerUUID,
    setUserUUID,
    userUUID,
    customerUUID,
    chat,
    addMessage,
    setChat,
    setConversationUUID,
  } = useSocketStore();
  const { setCurrentScreen, chatbotTheme } = useChatStore();

  const shopUrl = window.location.href;
  const domain = new URL(shopUrl).host;
  const audioRef = useRef(
    new Audio(`${API_URL}common/gif/notificationSound.wav`)
  );
  const assistMsg =
    "welcome to Lopaa AI Agent, your AI assistant. Please type your message here to proceed. Your message will be processed by our AI to resolve your issue, and if I'm unable to assist, I'll connect you with one of our team members.";

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseReceived, setResponseReceived] = useState(false);
  const [connectigAgent, setConnectingAgent] = useState(false);

  const AddAutoReply = () => {
    addMessage({
      senderType: "Chatbot",
      message: "Please Enter Your Email ID",
    });
  };

  const sendCustomerMessage = (message) => {
    if (!socketInstance) {
      console.error("Socket not initialized");
      return;
    }

    const payload = {
      message,
      shopID: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
      customerUuid: customerUUID,
      userUuid: userUUID,
    };
    socketInstance.emit("customer-to-user-message", payload);
    addMessage({
      senderType: "Customer",
      message: message,
    });

    setMessage("");
  };

  const handleSendMessage = (message) => {
    try {
      if (chat[chat.length - 1].message === "Please Enter Your Email ID") {
        disconnectSocket();
        setLoading(true);
        const payload = {
          email: message,
          shopID: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
        };
        getCustomerInfo(payload).then((res) => {
          if (res.status === 201) {
            setLoading(false);
            setMessage("");
            addMessage({
              senderType: "Customer",
              message: message,
            });
            const customerJsonPromise = res.json();
            customerJsonPromise.then((customerResp) => {
              setTimeout(() => {
                addMessage({
                  senderType: "Chatbot",
                  message: `Hi ${customerResp?.payload.customer.fullName}`,
                });
              }, [1000]);
              setTimeout(() => {
                addMessage({
                  senderType: "Chatbot",
                  message: assistMsg,
                });
              }, [2000]);
              setCustomerUUID(customerResp?.payload.customer.uuid);
            });
          } else {
            setLoading(false);
          }
        });
      } else if (chat[chat.length - 1].message === assistMsg) {
        setLoading(true);
        const payload = {
          question: message,
        };
        const shopId =
          domain === "localhost:3000" ? "sulopa.myshopify.com" : domain;
        getFaqRelatedAnswer(payload, shopId).then((res) => {
          if (res.status === 201) {
            setLoading(false);
            setMessage("");
            addMessage({
              senderType: "Customer",
              message: message,
            });
            const customerJsonPromise = res.json();
            customerJsonPromise.then((customerResp) => {
              setTimeout(() => {
                addMessage({
                  senderType: "Chatbot",
                  message: customerResp?.payload.answer,
                });
              }, [1000]);
              setTimeout(() => {
                addMessage({
                  senderType: "Chatbot",
                  message: [
                    "I'm satisfied with this response.",
                    "I need further assistance.",
                  ],
                });
              }, [3000]);
            });
          } else {
            setLoading(false);
          }
        });
      } else if (socketInstance && userUUID) {
        sendCustomerMessage(message);
      }
    } catch {}
  };

  const handleOption = (opt) => {
    addMessage({
      senderType: "Customer",
      message: opt,
    });
    if (opt === "I need further assistance." || opt === "Restart chat") {
      connectSocket(customerUUID);
    } else {
      setTimeout(() => {
        addMessage({
          senderType: "Chatbot",
          message: "Thank you! Have a great day. 😊 ",
        });
      }, [1000]);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      AddAutoReply();
    }, [1000]);
  }, []);

  useEffect(() => {
    if (socketInstance && customerUUID && !userUUID) {
      const payload = {
        message: message,
        shopID: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
        customerUuid: customerUUID,
      };

      setTimeout(() => {
        setConnectingAgent(true);
      }, 1000);

      const intervalId = setInterval(() => {
        if (!responseReceived) {
          socketInstance.emit("connecting-to-user", payload);
        }
      }, 10000);

      return () => clearInterval(intervalId);
    }
  }, [customerUUID, socketInstance, responseReceived, userUUID]);

  useEffect(() => {
    if (socketInstance) {
      const handleUserToCustomerMessage = (response) => {
        if (response.conversationUuid) {
          setUserUUID(response.userUuid);
          setConversationUUID(response.conversationUuid);
          addMessage({
            senderType: "Chatbot",
            message: response.message,
          });
          audioRef.current
            .play()
            .catch((error) => console.error("Audio play error:", error));
          setResponseReceived(true);
          setConnectingAgent(false);
        } else {
          console.error("Failed to initialize conversation:", response.error);
        }
      };

      const handleChatClose = (response) => {
        addMessage({
          senderType: "Chatbot",
          message: response.message,
        });
        audioRef.current
          .play()
          .catch((error) => console.error("Audio play error:", error));
        setTimeout(() => {
          disconnectSocket();
          setUserUUID("");
          setConversationUUID("");
          setResponseReceived(false);
          addMessage({
            senderType: "Chatbot",
            message: ["Restart chat"],
          });
        }, [2000]);
      };

      socketInstance.on(
        "user-to-customer-message",
        handleUserToCustomerMessage
      );
      socketInstance.on("chat:close", handleChatClose);

      return () => {
        socketInstance.off(
          "user-to-customer-message",
          handleUserToCustomerMessage
        );
        socketInstance.off("chat:close", handleChatClose);
      };
    }
  }, [socketInstance]);

  return (
    <>
      <div
        className="chat-box-container"
        style={{ display: "flex", flexDirection: "column-reverse" }}
      >
        <div className="chat-body-container">
          {chat.map((msg, index) => (
            <div key={index} className="chat-box-customer">
              {msg.senderType === "Customer" ? (
                <div
                  className="customer-issue"
                  style={{ marginTop: "0px", backgroundColor: chatbotTheme }}
                >
                  <label>{msg.message}</label>
                </div>
              ) : (
                <>
                  {index === 0 ? (
                    <div
                      className="chat-box-text-container"
                      style={{ maxWidth: "80%" }}
                    >
                      <div className="chat-box-text">
                        Hi There, Welcome to lopaa <br /> Are you a Lopaa
                        customer ? <br /> Please enter your email address to
                        verify your account.
                      </div>
                    </div>
                  ) : (
                    <>
                      {typeof msg.message === "object" ? (
                        <div
                          className="auto-chat-option"
                          style={{ marginTop: 0, marginLeft: 0, gap: 8 }}
                        >
                          {msg.message.map((opt, optIdx) => (
                            <label
                              key={optIdx}
                              onClick={() =>
                                !socketInstance ? handleOption(opt) : {}
                              }
                              style={{ border: `1px solid ${chatbotTheme}` }}
                            >
                              {opt}
                            </label>
                          ))}
                        </div>
                      ) : (
                        <div className="chat-box-text-container">
                          <div className="chat-box-text">{msg.message}</div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          ))}
          {connectigAgent && (
            <div className="chat-box-text-container">
              <div
                className="chat-box-text"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: 0,
                  paddingLeft: 12,
                  paddingRight: 12,
                  gap: 1,
                }}
              >
                <label>connecting to agent</label>
                <img
                  src={`${API_URL}common/gif/LoadingAnimation.gif`}
                  style={{ width: 35, height: 35 }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <ChatFooter
        message={message}
        setMessage={setMessage}
        handleChatMessage={handleSendMessage}
        loading={loading}
      />
    </>
  );
};

export default OneToOneChat;
